import { defineComponent, computed, inject } from 'vue';
import { useStoreModule } from '../../composables/store-module/index.js';
import { useImageLoading } from '../../composables/image-loading/index.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "CompanyLogo",
  props: {
    id: { type: null, required: true },
    alt: { type: String, required: false, default: "logo" },
    size: { type: null, required: false },
    format: { type: null, required: false, default: "rectangular" }
  },
  emits: ["store-error", "data-load"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const componentInputs = computed(() => {
      var _a;
      return {
        id: props.id,
        size: (_a = props.size) != null ? _a : null,
        format: props.format
      };
    });
    const storeModule = useStoreModule(
      { storeModule: inject("storeModule") },
      componentInputs,
      emits
    );
    const { isLoadingStoreData, storeData } = storeModule;
    const url = computed(() => {
      var _a, _b;
      return (_b = (_a = storeData.value) == null ? void 0 : _a.url) != null ? _b : null;
    });
    const { imageLoading, watchImage } = useImageLoading();
    const isLoading = computed(() => isLoadingStoreData.value || !!url.value && imageLoading(url.value));
    return { __sfc: true, props, emits, componentInputs, storeModule, isLoadingStoreData, storeData, url, imageLoading, watchImage, isLoading };
  }
});

export { _sfc_main as default };
